export interface Packung {
  anzahl  : number;
  groesse : string;
}

export class PackungCmd {
  anzahl  : number | null = null;
  groesse : string | null = null;

  public constructor(init?: Partial<PackungCmd>) {
    Object.assign(this, init);
  }
}

export function clonePackung(original?: Packung): PackungCmd {
  return new PackungCmd({
    anzahl  : original?.anzahl,
    groesse : original?.groesse
  });
}
